export const ASSETS = {
  logo: "https://static.prod-images.emergentagent.com/jobs/eb1490f2-33ad-4260-85a9-86d48a358fa8/images/aeb5c577d3067ba72cf552e10fad18bcbbca4e37c075c8754ee2d792083b48ae.jpeg",
  worldMap: "https://static.prod-images.emergentagent.com/jobs/eb1490f2-33ad-4260-85a9-86d48a358fa8/images/4a9be720bd63aca71801f25eb70a2c594e360a81b12dd03585b900718af8d7ad.jpeg",
};
